import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import MuiButton from '@mui/material/Button'
import LinearProgress from '@mui/material/LinearProgress'

interface DeleteConfirmationParams {
  open: boolean
  isLoading: boolean
  onCancel: () => void
  onConfirm: () => void
  alignText?: 'left' | 'center' | 'right'
  title?: string
  description?: string
  cancelText?: string
  confirmText?: string
}

function DeleteConfirmation (props: DeleteConfirmationParams) {
  return (
    <Dialog
      open={props.open}
      onClose={props.onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {props.isLoading && <LinearProgress />}
      <DialogTitle id="alert-dialog-title" style={{ textAlign: props.alignText || 'center' }}>
        {props.title || 'Are you sure?'}
      </DialogTitle>
      <DialogContent style={{ textAlign: props.alignText || 'center' }}>
        <DialogContentText id="alert-dialog-description">
          {props.description || 'This record will be deleted'}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ textAlign: props.alignText || 'center' }}>
        <MuiButton
          onClick={props.onCancel}
          variant='outlined'
          style={{ marginLeft: 'auto' }}
          size='small'
          disabled={props.isLoading}
        >
          {props.cancelText || 'Cancel'}
        </MuiButton>
        <MuiButton
          onClick={props.onConfirm}
          autoFocus
          variant='contained'
          style={{ marginRight: 'auto' }}
          size='small'
          disabled={props.isLoading}
        >
          {props.confirmText || 'Confirm'}
        </MuiButton>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteConfirmation
